'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var slicedToArray = require('./../../../external/@babel/runtime/helpers/esm/slicedToArray.js');
var React = require('react');
var index = require('./../../../external/classnames/index.js');
require('../../../utilities/GatsbyLink/index.js');
require('../../../primitives/Hero/Hero.js');
require('../../../primitives/HeroSrcSet/HeroSrcSet.js');
var Icon = require('../../../primitives/Icon/Icon.js');
require('../../../primitives/Link/Link.js');
var ContentBody = require('../../ContentBody/ContentBody.js');
var useHash = require('../../../utilities/hooks/useHash.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);

/**
 * An Accordion Item
 *
 * @param {Object} props - The props object for the component.
 * @param {string} props.title - The title of the accordion item.
 * @param {React.ReactNode | string} props.content - The content of the accordion item.
 * @param {boolean} [props.open] - Whether the accordion item is open by default.
 * @param {boolean} [props.isReact] - Whether the content is React or HTML.
 * @param {string} [props.id] - The id of the accordion item.
 *
 * @example
 * // Defaults open=false, isReact=false
 * <AccordionItem
 *  title='Accordion Item Title'
 * content='Accordion Item Content'
 * />
 *
 * @returns {JSX.Element} The rendered accordion item component.
 */

var AccordionItem = function AccordionItem(_ref) {
  var title = _ref.title,
    content = _ref.content,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    _ref$isReact = _ref.isReact,
    isReact = _ref$isReact === void 0 ? false : _ref$isReact,
    id = _ref.id;
  var _useState = React.useState(open),
    _useState2 = slicedToArray.default(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var hash = useHash.default();
  var contentClasses = index.default('lanl-accordion-item-content', isOpen && 'open');
  React.useEffect(function () {
    if (window.location.hash === "#".concat(id)) {
      setIsOpen(true);
    }
  }, [hash]);
  return /*#__PURE__*/React__default.default.createElement("div", {
    id: id,
    className: "lanl-accordion-item"
  }, /*#__PURE__*/React__default.default.createElement("button", {
    className: "lanl-accordion-item-button",
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, title, /*#__PURE__*/React__default.default.createElement(Icon.Icon, {
    icon: "chevron-".concat(isOpen ? 'up' : 'down'),
    size: "sm",
    className: "lanl-accordion-item-button-icon"
  })), /*#__PURE__*/React__default.default.createElement("div", {
    "data-testid": "lanl-accordion-item-content",
    className: contentClasses
  }, /*#__PURE__*/React__default.default.createElement(ContentBody.ContentBody, {
    isHTML: !isReact,
    body: content
  })));
};

exports.AccordionItem = AccordionItem;
exports.default = AccordionItem;
//# sourceMappingURL=AccordionItem.js.map
